import { useMutation, useQueryClient } from "@tanstack/react-query";
import { useNavigate } from "react-router-dom";
import authService from "../services/auth.service";
import toast from "react-hot-toast";

export const useLogin = () => {
  const queryClient = useQueryClient();
  const navigate = useNavigate();

  const { isPending: isLoading, mutate: login } = useMutation({
    mutationFn: (data) => authService.login(data.email, data.password, data.rememberMe),
    onSuccess: (user) => {
      toast.success("Login successfully");
      queryClient.setQueryData(["user"], user);
      navigate("/home");
    },
    onError: (err) => {
      toast.error(err.response?.data?.message || "Something went wrong");
    },
  });
  return { login, isLoading };
};
